import classNames from 'classnames';
import React from 'react';
import {
	ProductIcon,
	ProductIconType,
} from 'cond-ui-kit';



type Props = {
	/** Completed state of achievement */
	isDone: boolean,
	/** Callback triggered on click */
	onClick: () => void,
	/** Description of achievement */
	label: React.ReactNode,
};



const Achievement: React.FC<Props> = (props) => {
	const {
		isDone,
		label,
		onClick,
	} = props;

	const componentClasses = classNames({
		'profile-completeness-achievement': true,
		'profile-completeness-achievement--is-completed': isDone,
	});

	return (
		<div
			className={componentClasses}
			onClick={onClick}
		>
			<div className="profile-completeness-achievement__icon">
				{isDone ? (
					<div className="profile-completeness-achievement__checkmark-bg">
						<ProductIcon
							color="#41CC67"
							size={24}
							type={ProductIconType.CheckmarkCircle}
						/>
					</div>
				) : (
					<ProductIcon
						color="rgba(255, 255, 255, 1)"
						size={24}
						type={ProductIconType.ArrowRight}
					/>
				)}
			</div>
			<div className="profile-completeness-achievement__label">
				{label}
			</div>
		</div>
	);
};



export default Achievement;
